module.exports = __webpack_public_path__ + "media/images/about-us/pc2-29f14eb3342c763685f165493297f7be.jpeg";